import { render, staticRenderFns } from "./InformationList.vue?vue&type=template&id=f886ac50&scoped=true&"
import script from "./InformationList.vue?vue&type=script&lang=js&"
export * from "./InformationList.vue?vue&type=script&lang=js&"
import style0 from "./InformationList.vue?vue&type=style&index=0&id=f886ac50&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f886ac50",
  null
  
)

export default component.exports